import React from "react";
import { Link } from "react-router-dom";

const OrderSuccess = () => {
  return (
    <section className="mt-120 mb-90 ">
      <div className="container bg-light">
        <div className="d-flex justify-content-center pt-120 pb-60">
          <img
            src="assets\images\icon\checklist.png"
            alt=""
            className="custom-tick"
          />
        </div>
        <div className="text-center productSuccess-context pb-120">
          <h5>Your order is successfully placed</h5>
          <p>
            Your order has been successfully placed and is now being processed.
            We'll send you a confirmation email with your order details shortly.
            If you have any questions, feel free to contact our support team. We
            appreciate your business and hope to serve you again soon!
          </p>
          <div className="d-flex justify-content-center">
            <Link
              to="/my-order"
              className="btn btn-main d-inline-flex align-items-center gap-8 mt-30"
            >
              VEIW ORDERS
              <span className="icon text-xl d-flex">
                <i className="ph ph-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderSuccess;
